export default "__VITE_ASSET__DxvQaGWf__"